import { useRouter } from "next/navigation";
import React from "react";
import { Divider } from "staysure-component-library";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import withBrand from "@/components/with-brand";
import useGtmCustomEvent from "@/hooks/gtm/use-gtm-custom-events";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import { BrandKey } from "@/types/common-types";

type ContactDetailsType = {
  organizerDetailsTitle: string;
  organizerAddressEditButtonLabel: string;
  organiserName: string;
  organiserAddress: string;
  postalCode: string;
  brand?: BrandKey;
};

function OrganizerDetails({
  organizerDetailsTitle,
  organizerAddressEditButtonLabel,
  organiserName,
  organiserAddress,
  postalCode,
  brand = "staysure",
}: Readonly<ContactDetailsType>) {
  const router = useRouter();
  const { updateLastEditAccordion } = useRenewalStateContext();

  const handleGtmEvent = useGtmCustomEvent({
    event: "custom_events",
    eventName: "edit_cta",
    quoteSection: "contact details",
  });

  return (
    <div className="flex flex-col">
      <h2
        className={`font-header-font ${
          brand === "avanti"
            ? "leading-[26px] text-m md:leading-[23px] md:text-s lg:leading-[26px] lg:text-m"
            : "leading-[28px]  md:text-l lg:text-xls text-xls font-[400]"
        }  text-text-title mb-spacing-m mt-spacing-xl`}
      >
        {organizerDetailsTitle}
      </h2>
      <div className="flex justify-between items-start">
        <div>
          <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default word-break max-w-[241px]">
            {organiserName}
          </p>
        </div>
      </div>
      <Divider margin={12} color="#DCDCDC" />
      <div className="flex justify-between items-start">
        <div>
          <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default word-break max-w-[241px]">
            {organiserAddress}
            <br />
            {postalCode}
          </p>
        </div>
        <div>
          <LabelButtonWrapper
            label={organizerAddressEditButtonLabel}
            hierarchy="tertiary"
            className="font-body-font leading-[18px] font-[600] text-xs realtive top-[-2px] !px-spacing-xxs"
            onClick={() => {
              updateLastEditAccordion("contact-details");
              handleGtmEvent();
              router.push("/organiser-edit");
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default withBrand(OrganizerDetails);
